module.exports = __webpack_public_path__ + "media/images/pic/courses/benefit01-1df745021fe7bb10b4d97842854a3a14.svg";